import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-external-link',
    templateUrl: './external-link.component.html',
    styleUrl: './external-link.component.scss',
    standalone: false
})
export class ExternalLinkComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public url: string) {}
}
